import React from "react"
import {  FiChevronDown, FiChevronLeft } from "react-icons/fi";
 
export const ProfessionItem = ({item, index}) =>{
    const [open,setOpen] = React.useState(item?.active);
    const [close] = React.useState(!(item?.children?.length>0))
    const handle = () => {
        setOpen(!open)
    } 

    return (
        <li className="dropdown" >
            <a  className={item.active?'active':''} >
                <p>{item.title}  </p>
               <div onClick={handle}> 
                {open? <FiChevronDown />: (close?<></>:<FiChevronLeft /> )}
               </div>
            </a>
            {item?.children?.length>0 && (
                <ul className={`sub_category_lists ${close || !open?'hidden':''}`} >
                    {item.children?.map((child,i)=>{
                        return (
                        <li 
                            className={child.active?'active':''}
                            key={`profession-child-${i}`} >
                                <a><p>{child.title}</p></a>
                        </li>
                        )
                    })}
                </ul>
            )}
        </li>
    )
}

